import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Login: React.FC = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const { login } = useAuth();
  const navigate = useNavigate();


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (error) setError('');
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const success = await login(formData.username, formData.password);
      if (success) {
        navigate('/dashboard');
      } else {
        setError('Invalid username or password');
      }
    } catch (error) {
      setError('Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="account-pages">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6 col-xl-5">
            <div className="card overflow-hidden">
              <div className="card-body">
                <div className="auth-logo">
                  <a href="/dashboard" className="auth-logo-light">
                    <div className="avatar-md profile-user-wid mb-3">
                      <span className="avatar-title rounded-circle bg-light">
                        <img src="/assets/images/colored_logo.png" alt="Nyvro Logo" height="34" style={{ objectFit: 'contain' }} />
                      </span>
                    </div>
                  </a>
                  <a href="/dashboard" className="auth-logo-dark">
                    <div className="avatar-md profile-user-wid mb-3">
                      <span className="avatar-title rounded-circle bg-light">
                        <img src="/assets/images/colored_logo.png" alt="Nyvro Logo" height="34" style={{ objectFit: 'contain' }} />
                      </span>
                    </div>
                  </a>
                  <h4 className="text-primary mb-4" style={{ color: '#006175' }}>Welcome Back</h4>
                </div>
                <div className="p-2">
                  <form className="form-horizontal" onSubmit={handleSubmit}>
                    {error && (
                      <div className="alert alert-danger" role="alert">
                        {error}
                      </div>
                    )}

                    <div className="mb-3">
                      <label htmlFor="username" className="form-label">Username</label>
                      <input
                        type="text"
                        className="form-control"
                        id="username"
                        name="username"
                        placeholder="Enter username"
                        value={formData.username}
                        onChange={handleChange}
                        required
                        disabled={isLoading}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Password</label>
                      <div className="input-group auth-pass-inputgroup">
                        <input
                          type={showPassword ? 'text' : 'password'}
                          className="form-control"
                          name="password"
                          placeholder="Enter password"
                          aria-label="Password"
                          aria-describedby="password-addon"
                          value={formData.password}
                          onChange={handleChange}
                          required
                          disabled={isLoading}
                        />
                        <button
                          className="btn btn-light"
                          type="button"
                          id="password-addon"
                          onClick={() => setShowPassword(!showPassword)}
                          disabled={isLoading}
                        >
                          <i className={`mdi ${showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'}`}></i>
                        </button>
                      </div>
                    </div>

                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" id="remember-check" />
                      <label className="form-check-label" htmlFor="remember-check">
                        Remember me
                      </label>
                    </div>

                    <div className="mt-3 d-grid">
                      <button
                        className="btn btn-primary waves-effect waves-light"
                        type="submit"
                        disabled={isLoading}
                        style={{ backgroundColor: '#006175', borderColor: '#006175' }}
                      >
                        {isLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Logging In...
                          </>
                        ) : (
                          'Log In'
                        )}
                      </button>
                    </div>

                    <div className="mt-4 text-center">
                      <Link to="/forgot-password" className="text-muted">
                        <i className="mdi mdi-lock me-1"></i> Forgot your password?
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="mt-5 text-center">
              <div>
                <p>© {new Date().getFullYear()} Midnite Spark. Crafted with <i className="mdi mdi-heart text-danger"></i> by Nyvro</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
